// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2E2mX","footer":"ModalInfo_footer__fpxLs"};